import React from 'react';
import {
  REPLACE_DRAFT_BODY,
  REPLACE_DRAFT_GO,
  REPLACE_DRAFT_KEEP,
  REPLACE_DRAFT_TITLE,
} from '../../utils/writerCopy';
import ShrinkGuardDialog from './ShrinkGuardDialog';

/**
 * Ask before a new draft replaces an unaccepted one (#2385).
 * Keep this draft is the default. Write a new one continues into today's write.
 */
export default function ReplaceUnacceptedDraftDialog({ onCancel, onGoAhead }) {
  return (
    <ShrinkGuardDialog
      title={REPLACE_DRAFT_TITLE}
      body={REPLACE_DRAFT_BODY}
      keepLabel={REPLACE_DRAFT_KEEP}
      confirmLabel={REPLACE_DRAFT_GO}
      titleId="sw-replace-draft-title"
      className="sw-shrink-guard-backdrop--dock-bottom"
      onSave={onGoAhead}
      onKeepEditing={onCancel}
    />
  );
}
